import { render, staticRenderFns } from "./InstallPwaButton.vue?vue&type=template&id=64cdfc0b&scoped=true"
import script from "./InstallPwaButton.vue?vue&type=script&lang=js"
export * from "./InstallPwaButton.vue?vue&type=script&lang=js"
import style0 from "./InstallPwaButton.vue?vue&type=style&index=0&id=64cdfc0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cdfc0b",
  null
  
)

export default component.exports